import { Outlet } from 'react-router';
import useAuth from 'src/hooks/useAuth';
import LoadingPanel from '../LoadingPanel';

const AuthGaurd = () => {
  const { user } = useAuth();
  if (!user || Object.keys(user).length <= 1) {
    return <LoadingPanel />;
  }
  return <Outlet />;
};

export default AuthGaurd;
